module.exports = __webpack_public_path__ + "static/media/hoergeraet.22808a88.jpg";